<template>
 <div class="card edit">
  <div class="card-body">
   <div class="d-flex align-items-center justify-content-between">
    <h5>Leerlingen bewerken</h5>
    <div>
     <a
      class="btn btn-outline-primary btn-sm me-1"
      @click="newItem"
     >Nieuwe leerling
      <font-awesome-icon icon="plus-circle" />
     </a>
     <a
      class="btn btn-outline-primary btn-sm"
      @click="$parent.detailEdit = ''"
     >Sluiten
      <font-awesome-icon icon="window-close" />
     </a>
    </div>
   </div>
   <div class="row mt-3">
    <div class="col">
     <div
      class="card mb-3"
      v-if="mode !== ''"
     >
      <div class="card-body row">
       <div class="col">
        <div class="form-floating mb-2">
         <input
          type="text"
          class="form-control"
          :class="{ 'is-invalid': $v.pupil.achternaam.$error }"
          id="lastname"
          v-model="pupil.achternaam"
         />
         <label for="lastname">Achternaam</label>
        </div>
        <div class="form-floating mb-2">
         <input
          type="text"
          class="form-control"
          id="prefix"
          v-model="pupil.voorvoegsel"
         />
         <label for="prefix">Voorvoegsel</label>
        </div>
        <div class="form-group mb-2">
         <label>Jaargroep</label>
         <multiselect
          v-model="pupil.jaargroep"
          placeholder="Kies een Jaargroep"
          label="naam"
          track-by="key"
          :class="{ 'is-invalid': $v.pupil.jaargroep.$error }"
          :selectLabel="'Selecteren'"
          :deselectLabel="'Verwijderen'"
          :selectedLabel="'Geselecteerd'"
          :hideSelected="true"
          :options="yearGroupOptions"
          :multiple="false"
         ></multiselect>
        </div>

        <a
         class="btn btn-outline-primary btn-sm me-1"
         @click="cancelItem"
        >Cancel
         <font-awesome-icon icon="window-close" />
        </a>
        <a
         class="btn btn-secondary btn-sm"
         @click="saveItem"
        >Leerling opslaan
         <font-awesome-icon icon="save" />
        </a>
       </div>
       <div class="col">
        <div class="form-floating mb-2">
         <input
          type="text"
          class="form-control"
          id="initials"
          maxlength="1"
          v-model="pupil['voorletters-1']"
         />
         <label for="initials">Voorletters</label>
        </div>
        <div class="form-floating mb-2">
         <input
          type="text"
          class="form-control"
          id="name"
          v-model="pupil.roepnaam"
         />
         <label for="name">Roepnaam</label>
        </div>

        <div class="form-group mb-2">
         <label>Groep</label>
         <multiselect
          v-model="pupil.groep"
          placeholder="Kies een Groep"
          label="naam"
          track-by="naam"
          :class="{ 'is-invalid': $v.pupil.groep.key.$error }"
          :selectLabel="'Selecteren'"
          :deselectLabel="'Verwijderen'"
          :hideSelected="true"
          :selectedLabel="'Geselecteerd'"
          :options="groupOptions"
          :multiple="false"
         ></multiselect>
        </div>
        <div
         v-if="this.content.groepen.samengestelde_groep"
         class="form-group mb-2"
        >
         <label>Samengestelde groep</label>
         <multiselect
          v-model="pupil.samengestelde_groepen.samengestelde_groep"
          placeholder="Kies een Samengestelde groep"
          label="naam"
          track-by="naam"
          :hideSelected="true"
          :selectLabel="'Selecteren'"
          :deselectLabel="'Verwijderen'"
          :selectedLabel="'Geselecteerd'"
          :options="composedGroupOptions"
          :multiple="true"
         ></multiselect>
        </div>
       </div>
      </div>
     </div>
     <!-- OVERVIEW -->
     <div
      class="accordion"
      id="overview-accordion"
     >
      <div class="accordion-item">
       <h2
        class="accordion-header"
        id="overview"
       >
        <button
         class="accordion-button"
         type="button"
         data-bs-toggle="collapse"
         data-bs-target="#overview-list"
         aria-expanded="true"
         aria-controls="overview-list"
        >Overzicht Leerlingen</button>
       </h2>
       <div
        id="overview-list"
        class="accordion-collapse collapse show"
        aria-labelledby="overview"
        data-bs-parent="#overview"
       >
        <div class="accordion-body">
         <ul class="list-group">
          <li
           :id="index"
           v-for="(leerling, index) in content.leerlingen.leerling"
           :key="leerling.key.key"
           class="list-group-item d-flex align-items-center justify-content-between"
          >
           <div :title="`${leerling.roepnaam} ${leerling.achternaam}`">
            {{ leerling.roepnaam }} {{ leerling.voorvoegsel }} {{ leerling.achternaam }}
            <small> - ({{ leerling.groep.naam }})</small>
           </div>
           <span>
            <button
             :disabled="disableButtons"
             class="btn btn-outline-primary btn-sm me-2"
             @click="editItem(index)"
            >
             Bewerk
             <font-awesome-icon icon="edit" />
            </button>
            <button
             :disabled="disableButtons"
             class="btn btn-outline-primary btn-sm"
             @click="deleteItem(index)"
            >
             Verwijder
             <font-awesome-icon icon="trash-alt" />
            </button>
           </span>
          </li>
         </ul>
        </div>
       </div>
      </div>
     </div>
    </div>
   </div>
  </div>
 </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import getUniqueKey from "@/helpers/getUniqueKey";
import { yearGroupOptionsPupils } from "@/constants/yearGroupOptions";

const getInitPupil = () => {
 return {
  key: { key: "" },
  groep: { key: {} },
  samengestelde_groepen: { samengestelde_groep: null },
 };
};

export default {
 name: "pupilEdit",
 props: {
  content: {
   type: Object,
   required: true,
  },
 },
 data() {
  return {
   pupil: getInitPupil(),
   mode: "",
   yearGroupOptions: yearGroupOptionsPupils,
   groupOptions: this.content.groepen.groep,
   composedGroupOptions: this.content.groepen.samengestelde_groep,
   disableButtons: false,
  };
 },
 validations: {
  pupil: {
   achternaam: {
    required,
   },
   jaargroep: {
    required,
   },
   groep: { key: { required } },
  },
 },
 methods: {
  saveItem() {
   this.$v.$touch();
   if (this.$v.$invalid) return;

   if (this.mode === "new") {
    this.pupil.key.key = getUniqueKey();
    this.content.leerlingen.leerling.push(this.pupil);
    this.$toast.success("Leerling toegevoegd");
    this.mode = "";
    this.disableButtons = false;
   } else {
    let originalPupils = [...this.content.leerlingen.leerling];
    let getPupilId = originalPupils.findIndex(
     (element) => element.key.key === this.pupil.key.key
    );
    originalPupils[getPupilId] = {
     ...originalPupils[getPupilId],
     ...this.pupil,
    };
    this.content.leerlingen.leerling = originalPupils;

    this.$toast.success("Leerling gewijzigd");
    this.mode = "";
    this.$v.$reset();
    this.group = getInitPupil();
    this.disableButtons = false;
   }
  },
  newItem() {
   this.disableButtons = true;
   this.mode = "new";
   this.$v.$reset();
   this.pupil = getInitPupil();
  },
  editItem(i) {
   this.disableButtons = true;
   this.pupil = { ...this.content.leerlingen.leerling[i] };
   if (!this.pupil.samengestelde_groepen) {
    this.pupil.samengestelde_groepen = { samengestelde_groep: null };
   }
   this.mode = "edit";
   window.scrollTo(0, 0);
  },
  deleteItem(i) {
   this.$delete(this.content.leerlingen.leerling, i);
   this.$toast.success("Leerling verwijderd");
   window.scrollTo(0, 0);
  },
  cancelItem() {
   this.mode = "";
   this.$v.$reset();
   this.disableButtons = false;
   this.teacher = getInitPupil();
  },
 },
};
</script>
